import { useState, useEffect } from 'react';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

// import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import Typography from '@mui/material/Typography';
import { Divider, Stack } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { GreenSwitch } from '../../Styles';
import { OpenSwal, notistackSnakebar } from '../../Utils';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { FormControlLabel } from '@mui/material';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';


import LinearProgress from '@mui/material/LinearProgress';

import { useSnackbar } from 'notistack';



import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';

import { ScrollTypography } from '../../Styles';

import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';

import dayjs from 'dayjs';
import useMediaQuery from '@mui/material/useMediaQuery';
import Tooltip from '@mui/material/Tooltip';

import Checkbox from '@mui/material/Checkbox';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// import Divider from '@mui/material/Divider';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import FileViewerCustom from '../../Components/FileViewerCustom';
// import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

import InputLabel from '@mui/material/InputLabel';

import FormHelperText from '@mui/material/FormHelperText';

import OutlinedInput from '@mui/material/OutlinedInput';
import RaiseInvoiceDefaultComp from '../../Components/Interpreter/RaiseInvoiceDefaultComp';


import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { url_fetch_assignment_lists, url_get_assign_bill_details, url_insert_invoice } from '../../RoutesMap';
import { apiWithAuth } from '../../Services/Axios/axios';


export default function RaiseInvoice() {
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    const appThemeSecondaryColor = process.env.REACT_APP_THEME_SECONDARY_COLOR;
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [DialogBoxStatus, DialogBoxStatusSet] = useState(false);
    const [RaiseInvoiceStage, RaiseInvoiceStageSet] = useState('RaiseInvoice1');
    const [RaiseInvoiceStageHeading, RaiseInvoiceStageHeadingSet] = useState('Raise Invoice');
    const navigate = useNavigate();
    //page1
    const [UnBilledAssisgnmentAry, UnBilledAssisgnmentArySet] = useState([]);
    const [UnBilledAssisgnmentRateCardStatus, UnBilledAssisgnmentRateCardStatusSet] = useState(1);
    const [CheckedBillPreviewAry, CheckedBillPreviewArySet] = useState([]);
    const [RaiseInvoiceCheckboxList, RaiseInvoiceCheckboxListSet] = useState({});
    const [viewNewAssignmentRequestButtonSpin, viewNewAssignmentRequestButtonSpinSet] = useState(false);
    const [DisableApplyLocalTime, DisableApplyLocalTimeSet] = useState(true);
    const [viewNewAssignmentRequestButton, viewNewAssignmentRequestButtonSet] = useState(null);
    const [axiosuseEffectstatus, axiosuseEffectstatuslimitset] = useState('limit');

    const [selectedAssignmentCount, selectedAssignmentCountSet] = useState(0);
    const [assignmentTotalBillValue, assignmentTotalBillValueSet] = useState(0.00);


    const [AssignmentCheckSelectAllStatus, AssignmentCheckSelectAllStatusSet] = useState(false);
    const Apply_local_time_statelocalstorage = localStorage.getItem('Apply_local_time_state');

    const [ApplyLocalTimeState, ApplyLocalTimeStateSet] = useState((Apply_local_time_statelocalstorage) ? true : false);


    //page 2  //file upload page
    const [UploadOwnInvoiceFileData, UploadOwnInvoiceFileDataSet] = useState({ filename: null, blob: null, type: null });
    const [UploadOwnInvoiceFileError, UploadOwnInvoiceFileErrorSet] = useState(false);


    //upload own invoice final:

    const [InVoiceNumberErrorMsg, InVoiceNumberErrorMsgSet] = useState(false);

    const [InVoiceNumberValue, InVoiceNumberValueSet] = useState('');

    const [finalUploadOwnInvoiceSubmitLoadingButton, finalUploadOwnInvoiceSubmitLoadingButtonSet] = useState(false);
    const [finalDefaultInvoiceSubmitLoadingButton, finalDefaultInvoiceSubmitLoadingButtonSet] = useState(false);



    //Default invoice comp:
    const [DefaultInvoiceHeaderName, DefaultInvoiceHeaderNameSet] = useState("");







    //page1
    useEffect(() => {
        if (viewNewAssignmentRequestButton !== null) {
            loadAssignmentList();
        }
    }, [ApplyLocalTimeState]);

    useEffect(() => {
        loadAssignmentList();
    }, [viewNewAssignmentRequestButtonSpin]);

    useEffect(() => {
        if (AssignmentCheckSelectAllStatus) {
            SelectAllRemoveAllListCheckbox('select');
        }
    }, [UnBilledAssisgnmentAry]);

    const loadAssignmentList = () => {

        let payload = new FormData();

        payload.append('assign_status', 'unbilled');
        payload.append('status', axiosuseEffectstatus);
        payload.append('localtime', ApplyLocalTimeState);
        apiWithAuth.post(url_fetch_assignment_lists, payload, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                UnBilledAssisgnmentArySet(response.data.data);
                UnBilledAssisgnmentRateCardStatusSet(response.data.rate_card_status);
                DisableApplyLocalTimeSet(false);
                if (response.data.data.length === 0) {
                    viewNewAssignmentRequestButtonSet('no_records');
                } else if (response.data.data.length >= 4) {
                    if (axiosuseEffectstatus === "limit") viewNewAssignmentRequestButtonSet('view_all_requests_button');
                    else if (axiosuseEffectstatus === "all") {
                        viewNewAssignmentRequestButtonSet('hide_all');
                    }
                } else if (response.data.data.length < 4) {
                    viewNewAssignmentRequestButtonSet('hide_all');
                }

            } else if (response.data.status === false && response.data.message === "Token Expired") {
                OpenSwal('Token_error', navigate);
            } else {
                OpenSwal('Axios_error', response.data.message);
            }
        }).catch(response => {
            OpenSwal('Axios_error', response.message);
        });

    }
    const viewAllRequests = () => {
        axiosuseEffectstatuslimitset('all');
        viewNewAssignmentRequestButtonSpinSet(true);
    }
    const TriggerLocalTimeSwitch = (element) => {

        if (element.target.checked) localStorage.setItem('Apply_local_time_state', true);
        else localStorage.removeItem('Apply_local_time_state');
        ApplyLocalTimeStateSet(element.target.checked);
        // loadAssignmentList();
    }
    let ClientBoxwidth = 'auto';
    let minWidthabove800 = useMediaQuery('(width>800px)');
    let minWidth800 = useMediaQuery('(width<=800px)');
    let minWidth600 = useMediaQuery('(width<=600px)');
    let minWidth400 = useMediaQuery('(width<=400px)');
    let minWidth300 = useMediaQuery('(width<=300px)');
    if (minWidth300) {
        ClientBoxwidth = 150;
    } else if (minWidth400) {
        ClientBoxwidth = 170;
    } else if (minWidth600) {
        ClientBoxwidth = 230;
    } else if (minWidth800) {
        ClientBoxwidth = 200;
    } else if (minWidthabove800) {
        ClientBoxwidth = 'auto';
    }
    const SelectAllRemoveAllListCheckbox = (status) => {
        if (status === 'select') {
            AssignmentCheckSelectAllStatusSet(true);
            if (viewNewAssignmentRequestButton === 'view_all_requests_button') {
                viewAllRequests();
            } else {
                let all_values_array = {};
                UnBilledAssisgnmentAry.map((assign_data) => {
                    return (all_values_array[assign_data.assign_id_encry] = true);
                });
                RaiseInvoiceCheckboxListSet(all_values_array);
            }


        } else if (status === 'remove') {
            AssignmentCheckSelectAllStatusSet(false);
            RaiseInvoiceCheckboxListSet({});
        }
    }
    const CheckboxHandleChange = (assign_id_encry, checked_status) => {
        RaiseInvoiceCheckboxListSet({ ...RaiseInvoiceCheckboxList, [assign_id_encry]: checked_status });
        if (checked_status === false) {
            AssignmentCheckSelectAllStatusSet(false);
        }
    }
    useEffect(() => {
        if (viewNewAssignmentRequestButton !== null) {
            CheckSelectedAssignmentCount();
        }

    }, [RaiseInvoiceCheckboxList]);

    const CheckSelectedAssignmentCount = () => {
        let assign_count = 0;
        let assign_total_bill_value = 0;
        let assign_ids_array = [];
        Object.keys(RaiseInvoiceCheckboxList).forEach(key => {
            if (RaiseInvoiceCheckboxList[key]) {
                var get_bill_value = document.getElementById('assign_chk_' + key).getAttribute('data-billvalue');
                if (get_bill_value) {
                    assign_total_bill_value += parseFloat(get_bill_value);
                }
                assign_count++;
                assign_ids_array.push(key);
            }
        });
        selectedAssignmentCountSet(assign_count);
        assignmentTotalBillValueSet(assign_total_bill_value.toFixed(2));
        return assign_ids_array;
    }
    const PreviewDetails = () => {
        let get_checked_assign_ids = CheckSelectedAssignmentCount();
        if (get_checked_assign_ids.length > 0) {
            let payload = {
                assign_ids: get_checked_assign_ids
            };
            apiWithAuth.post(url_get_assign_bill_details, payload, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
                if (response.data.status) {
                    CheckedBillPreviewArySet(response.data.data);
                    DialogBoxStatusSet(true);

                } else if (response.data.status === false && response.data.message === "Token Expired") {
                    OpenSwal('Token_error', navigate);
                } else {
                    OpenSwal('Axios_error', response.data.message);
                }
            }).catch(response => {
                OpenSwal('Axios_error', response.message);
            });
        } else {
            notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: "Select Assignments", variant: 'error' });
        }
    }

    const NextPageTrigger = (status) => {
        if (status === 'RaiseInvoiceFileUpload') {
            let get_checked_assign_ids = CheckSelectedAssignmentCount();
            if (get_checked_assign_ids.length > 0) {
                if (UnBilledAssisgnmentRateCardStatus === 0) {
                    StageMaintain(status);
                } else {
                    notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: "You have applied for rate card modification. Please wait until it is acknowledged by you.", variant: 'error' });
                }
            } else {
                notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: "Select Assignments", variant: 'error' });
            }
        } else if (status === 'RaiseInvoiceFileUploadPreview') {
            StageMaintain(status);
        } else if (status === 'RaiseInvoiceFileUploadFinal') {
            StageMaintain(status);
        }

    }

    const StageMaintain = (status) => {
        if (status === 'RaiseInvoice1') {
            RaiseInvoiceStageSet('RaiseInvoice1');
            RaiseInvoiceStageHeadingSet('Raise Invoice');
        } else if (status === 'RaiseInvoiceFileUpload') {
            RaiseInvoiceStageSet('RaiseInvoiceFileUpload');
            RaiseInvoiceStageHeadingSet('Raise Invoice');
        } else if (status === 'RaiseInvoiceFileUploadPreview') {
            RaiseInvoiceStageSet('RaiseInvoiceFileUploadPreview');
            RaiseInvoiceStageHeadingSet('Upload Own Invoice');
        } else if (status === 'RaiseInvoiceFileUploadFinal') {
            InVoiceNumberErrorMsgSet(false);
            RaiseInvoiceStageSet('RaiseInvoiceFileUploadFinal');
            RaiseInvoiceStageHeadingSet('Upload Own Invoice');
        } else if (status === 'RaiseInvoiceDefaultPage') {
            RaiseInvoiceStageSet('RaiseInvoiceDefaultPage');
            RaiseInvoiceStageHeadingSet('Raise Default Invoice');
        }
    }


    const UploadOwnInvoiceFile = () => {
        let upload_own_invoice_file = document.getElementById('upload_own_invoice_file');
        if (upload_own_invoice_file.files[0]) {
            let filename = upload_own_invoice_file.files[0].name;
            let filename_extension_full = filename.split('.').pop();
            let filename_extension = filename_extension_full.toLowerCase();
            UploadOwnInvoiceFileDataSet({ filename: null, blob: null, type: null });
            if (upload_own_invoice_file.files[0].size <= '10000000') {
                if (filename_extension === 'png' || filename_extension === 'jpg' || filename_extension === 'jpeg' || filename_extension === 'pdf' || filename_extension === 'doc' || filename_extension === 'docx' || filename_extension === 'xls' || filename_extension === 'xlsx') {
                    UploadOwnInvoiceFileDataSet({ filename: filename, blob: URL.createObjectURL(upload_own_invoice_file.files[0]), type: filename_extension });
                    UploadOwnInvoiceFileErrorSet('ok');
                } else {
                    UploadOwnInvoiceFileErrorSet(filename_extension + ' file type is not acceptable');
                }
            } else {
                UploadOwnInvoiceFileErrorSet('Please ensure your file size does not exceed 10 MB.');
            }
        } else {
            UploadOwnInvoiceFileErrorSet(false);
        }
    }




    const RaiseInvoiceFileUploadSubmit = () => {
        let validation_check = true;
        InVoiceNumberErrorMsgSet(false);
        let get_checked_assign_ids = CheckSelectedAssignmentCount();
        if (get_checked_assign_ids.length === 0) {
            validation_check = false;
            notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: 'No Assignment Selected', variant: 'error' });
        }
        if (UploadOwnInvoiceFileError !== 'ok') {
            validation_check = false;
            notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: 'Invoice File is Not Uploaded', variant: 'error' });
        }
        let invoice_number = document.getElementById('invoice_number').value;


        if (invoice_number === '') {
            validation_check = false;
            InVoiceNumberErrorMsgSet('Invoice Number Required');
        }

        if (validation_check) {
            let formdata = new FormData();

            formdata.append('assign_ids', get_checked_assign_ids);
            formdata.append('invoice_number', invoice_number);

            let upload_own_invoice_file = document.getElementById("upload_own_invoice_file");
            formdata.append('upload_own_invoice_file', upload_own_invoice_file.files[0]);
            formdata.append('status', 'own_invoice');

            finalUploadOwnInvoiceSubmitLoadingButtonSet(true);
            apiWithAuth.post(url_insert_invoice, formdata, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
                if (response.data.status) {
                    finalUploadOwnInvoiceSubmitLoadingButtonSet(false);
                    if (response.data.message === 'success') {
                        notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: "Invoice No. " + InVoiceNumberValue + " is Successfully Submitted", variant: 'success' });
                        navigate('/Interpreter/SplashScreen', {
                            state: {
                                header: 'Congratulations!',
                                body: "Invoice No. " + InVoiceNumberValue + " is Successfully Submitted",
                                path: "/Interpreter/Raise_invoice"
                            }
                        });
                    } else if (response.data.message === 'duplicate') {
                        InVoiceNumberErrorMsgSet('Invoice number already exist!"');
                    }

                } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
                else {
                    finalUploadOwnInvoiceSubmitLoadingButtonSet(false);
                    OpenSwal('Axios_error', response.data.message);
                }
            }).catch(response => {
                finalUploadOwnInvoiceSubmitLoadingButtonSet(false);
                OpenSwal('Axios_error', response.message);
            });
        }
    }
    const RaiseInvoiceDefaultInvoiceSubmit = () => {
        let validation_check = true;

        let get_checked_assign_ids = CheckSelectedAssignmentCount();
        if (get_checked_assign_ids.length === 0) {
            validation_check = false;
            notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: 'No Assignment Selected', variant: 'error' });
        }

        if (validation_check) {
            let formdata = new FormData();
            formdata.append('assign_ids', get_checked_assign_ids);

            formdata.append('status', 'default_invoice');

            finalDefaultInvoiceSubmitLoadingButtonSet(true);
            apiWithAuth.post(url_insert_invoice, formdata, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
                if (response.data.status) {
                    finalDefaultInvoiceSubmitLoadingButtonSet(false);
                    notistackSnakebar(enqueueSnackbar, closeSnackbar, { message: "Invoice No. " + DefaultInvoiceHeaderName + " is Successfully Submitted", variant: 'success' });
                    navigate('/Interpreter/SplashScreen_Custom', {
                        state: {
                            header: 'Congratulations!',
                            body: "Invoice No. " + DefaultInvoiceHeaderName + " is Successfully Submitted",
                            path: "/Interpreter/Raise_invoice",
                            status: 'default_raise_invoice',
                            data: get_checked_assign_ids
                        }
                    });
                } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
                else {
                    finalDefaultInvoiceSubmitLoadingButtonSet(false);
                    OpenSwal('Axios_error', response.data.message);
                }
            }).catch(response => {
                finalDefaultInvoiceSubmitLoadingButtonSet(false);
                OpenSwal('Axios_error', response.message);
            });
        }
    }

    const ResetFilesInput = () => {
        document.getElementById("upload_own_invoice_file").value = "";
        UploadOwnInvoiceFileDataSet({ filename: null, blob: null, type: null });
        UploadOwnInvoiceFileErrorSet(false)
    }

    return (
        <Box  >
            <Box>
                <Dialog open={DialogBoxStatus} onClose={() => DialogBoxStatusSet(false)} fullScreen>
                    <DialogTitle sx={{ p: 1 }} variant='h6' align='center'  >
                        Preview
                    </DialogTitle>
                    <DialogContent sx={{ p: 1, backgroundColor: '#f5f5f5' }}>
                        <Box>
                            {CheckedBillPreviewAry.map((data, index) => {
                                var index_added = index + 1;
                                return (
                                    <Box key={index} sx={{ mb: 2 }}>
                                        <Grid container  > <Grid xs={1}> <Typography color={appThemeColor} variant='h6'>{index_added}</Typography> </Grid> <Grid xs={11}> <Typography color={appThemeColor} variant='h6'>{data.assign_order_id}</Typography> </Grid> </Grid>
                                        <Grid container  > <Grid xs={1}> </Grid> <Grid xs={8}> <Typography color={appThemeColor} variant='body2'>{data.language_name} - {data.assign_industry_name} - First {data.minimum_billing_time} </Typography> </Grid><Grid xs={3}> <Typography color={appThemeColor} align='right' variant='body2'>{data.assign_minimum_duration_amount}</Typography> </Grid> </Grid>
                                        {data.assign_interpreter_extra_duration !== 0 && <Grid container spacing={1}> <Grid xs={1}>   </Grid> <Grid xs={8}> <Typography color={appThemeColor} variant='body2'>{data.language_name} - {data.assign_industry_name}{' - > ' + data.assign_interpreter_extra_duration}</Typography> </Grid><Grid xs={3}> <Typography color={appThemeColor} align='right' variant='body2'>{data.assign_interpreter_extra_amount}</Typography> </Grid> </Grid>}
                                        {data.assign_interpreter_other_amount !== 0 && <Grid container spacing={1}> <Grid xs={1}>   </Grid> <Grid xs={8}> <Typography color={appThemeColor} variant='body2'>{data.assign_interpreter_other_labels}</Typography> </Grid><Grid xs={3}> <Typography color={appThemeColor} align='right' variant='body2'>{data.assign_interpreter_other_amount}</Typography> </Grid> </Grid>}
                                        {data.assign_interpreter_total_partpay !== 0 && <Grid container spacing={1}> <Grid xs={1}>   </Grid> <Grid xs={8}> <Typography color={appThemeColor} variant='body2'>Modified Bill Amount</Typography> </Grid><Grid xs={3}> <Typography color={appThemeColor} align='right' variant='body2'>{data.assign_interpreter_total_partpay}</Typography> </Grid> </Grid>}
                                        <Grid container mt={1} > <Grid xs={1}>   </Grid> <Grid xs={8}>  </Grid><Grid xs={3}>
                                            <Box>
                                                <Divider sx={{ backgroundColor: appThemeColor }} />
                                                <Typography color={appThemeColor} align='right'>{(data.assign_interpreter_total_partpay === 0) ? data.assign_interpreter_total_amount : data.assign_interpreter_total_partpay}</Typography>
                                                <Divider sx={{ backgroundColor: appThemeColor }} />
                                            </Box>
                                        </Grid> </Grid>
                                    </Box>
                                )
                            })}
                        </Box>
                    </DialogContent>
                    <DialogActions sx={{ display: 'unset' }}>
                        <Box sx={{ ml: 1, mr: 1, mb: 1 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                                <Typography>No. of Assignments</Typography>
                                <Typography>Total Amount</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                                <Box ml={7}>
                                    <Typography color={appThemeColor} fontWeight='bold'  >{selectedAssignmentCount}</Typography>
                                </Box>
                                <Typography color={appThemeColor} fontWeight='bold'>$ {assignmentTotalBillValue}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                <Button variant='contained' startIcon={<CloseIcon />} size='small' onClick={() => DialogBoxStatusSet(false)} color='error' sx={{ textTransform: 'none', width: 250 }}>Close</Button>
                            </Box>
                        </Box>
                    </DialogActions>
                </Dialog>
            </Box>
            <Box>

                <Box sx={{ mb: 25 }}>
                    <Grid container  >
                        <Grid xs={9} md={9} sm={9}>
                            <Box>
                                <Typography sx={{ typography: { xs: 'subtitle2', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '2px', textUnderlineOffset: '5px' }} >{RaiseInvoiceStageHeading}</Typography>
                            </Box>
                        </Grid>
                        <Grid xs={3} md={3} sm={3}>
                            {RaiseInvoiceStage === 'RaiseInvoice1' && <Box sx={{ position: 'relative', mt: -1 }}>
                                <FormControlLabel sx={{ position: 'absolute', top: '-1px', right: '-10px' }} control={<GreenSwitch onChange={TriggerLocalTimeSwitch} checked={ApplyLocalTimeState} disabled={DisableApplyLocalTime} />} label={<Typography variant="caption" sx={{ letterSpacing: '-0.5px', whiteSpace: 'nowrap', position: 'absolute', top: '28px' }} color="#4b4b4c" > Local Time</Typography>} labelPlacement="bottom" />
                            </Box>}
                        </Grid>
                    </Grid>

                    {/* Raise Invoice first page */}
                    {<Box display={RaiseInvoiceStage === 'RaiseInvoice1' ? 'block' : 'none'}>
                        {viewNewAssignmentRequestButton !== 'no_records' && <Box sx={{ mt: 1 }}>
                            <Stack spacing={0.5} direction='row'>
                                <Typography color={appThemeColor} sx={{ cursor: 'pointer', typography: { xs: 'caption', sm: 'body2', md: 'body2' }, textDecoration: (AssignmentCheckSelectAllStatus) ? 'underline' : 'none' }} onClick={() => SelectAllRemoveAllListCheckbox('select')}>Select All</Typography><Typography sx={{ typography: { xs: 'caption', sm: 'body2', md: 'body2' } }} color={appThemeColor}>|</Typography>
                                <Typography color={appThemeColor} sx={{ cursor: 'pointer', typography: { xs: 'caption', sm: 'body2', md: 'body2' } }} onClick={() => SelectAllRemoveAllListCheckbox('remove')}>Remove All</Typography>
                            </Stack>
                        </Box>}
                        {viewNewAssignmentRequestButton === null && <Box sx={{ mt: 5, mb: 5, display: 'flex', justifyContent: 'center' }}><LinearProgress color={appThemeSecondaryColor} sx={{ width: '70%', alignItems: 'center' }} /></Box>}
                        {viewNewAssignmentRequestButton !== null && <Grid container spacing={{ xs: 1.5, sm: 2, md: 2 }} sx={{ mt: 0.1 }}>  {UnBilledAssisgnmentAry.map((assign_data, index) => {
                            return (<Grid xs={12} sm={6} md={6} key={index}>
                                <Card sx={{ backgroundColor: '#fff', borderRadius: '10px' }} elevation={0} >
                                    <CardContent sx={{ padding: { xs: '5px', sm: '7px', md: '8px' }, height: { xs: '200px', sm: '210px', md: '230px' } }}  >
                                        <Grid container spacing={1} >
                                            <Grid xs={4} sm={4} md={4}  >
                                                <Card sx={{ backgroundColor: "#009F96", borderRadius: '15px', height: { xs: '80%', sm: '85%' } }}>
                                                    <CardContent sx={{ padding: { xs: '7px', sm: '7px', md: '8px' } }}>
                                                        <Typography sx={{ fontSize: { xs: '12px', sm: '13px' }}} color='#fff'> {assign_data.assign_request_day}</Typography>
                                                        <Typography sx={{ typography: { xs: 'h4', sm: 'h4' }, mb: -1 }} color='#fff'>{assign_data.assign_request_date_only}</Typography>
                                                        <Box sx={ScrollTypography}> <Typography color='#fff' sx={{ whiteSpace: 'nowrap', typography: { xs: 'body2', sm: 'body2', md: 'subtitle1' } }}  >{assign_data.assign_request_month_with_year}</Typography>
                                                        </Box>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                                                            <AccessTimeRoundedIcon sx={{ color: 'white', fontSize: { xs: '15px', sm: '16px', md: '20px' }, ml: '-2px', mr: 0.2 }} /> <Typography sx={{ whiteSpace: 'nowrap', typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }} color='#fff'  > {assign_data.assign_request_time_only.trim()}</Typography>
                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                            <Grid xs={8} sm={8} md={8}>
                                                <Box sx={{ width: ClientBoxwidth }}>
                                                    <Stack spacing={0.5} direction='row'>
                                                        <Box sx={ScrollTypography}> <Typography variant='subtitle1' sx={{ letterSpacing: '-0.2px', whiteSpace: 'nowrap', fontWeight: 'bold' }}>{assign_data.assign_order_id}</ Typography></Box><Box ><Typography variant='caption' color={appThemeColor} noWrap >| {assign_data.assign_industry_name}</Typography></Box>
                                                    </Stack>
                                                </Box>
                                                <Box sx={{ width: ClientBoxwidth }}>
                                                    <Box sx={ScrollTypography}   > <Typography variant='subtitle1' color={appThemeColor} sx={{ letterSpacing: '-0.2px', whiteSpace: 'nowrap' }}>{assign_data.assign_client_name}</ Typography></Box>
                                                </Box>
                                                <Typography color={appThemeColor} sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' }, whiteSpace: 'nowrap' }} style={{ letterSpacing: '-0.3px' }}  >{assign_data.service_type} | {assign_data.service_mode}</Typography>

                                                <Stack direction='row'>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', ml: '-15px' }}>
                                                        <TranslateOutlinedIcon sx={{ fontSize: { xs: '15px', sm: '16px', md: '20px' }, ml: 2, mr: 0.2 }} /><Typography style={{ letterSpacing: '-1px' }} sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' }, whiteSpace: 'nowrap' }} color={appThemeColor} >  {assign_data.language_name}</Typography>
                                                    </Box>

                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <AccessTimeRoundedIcon sx={{ fontSize: { xs: '15px', sm: '16px', md: '20px' }, ml: 2, mr: 0.2 }} /><Typography style={{ letterSpacing: '-1px' }} sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' }, whiteSpace: 'nowrap' }} color={appThemeColor} > {assign_data.assign_checkout_duration}</Typography>
                                                        <Tooltip arrow enterTouchDelay={0} title="Interpreted Duration" placement="top" >
                                                            <InfoOutlinedIcon sx={{ fontSize: { xs: '13px', sm: '14px', md: '16px' }, ml: 0.5, cursor: 'pointer' }} />
                                                        </Tooltip>
                                                    </Box>
                                                </Stack>
                                            </Grid>

                                        </Grid>
                                        <Box sx={{ mt: -1 }}>
                                            <Grid container spacing={1} >
                                                <Grid xs={6} sm={6} md={6}  >
                                                    <Box> <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }} style={{ letterSpacing: '-0.4px', fontWeight: 'bold' }}> Start Time </Typography> </Box>
                                                    <Box> <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }} color={appThemeColor} style={{ whiteSpace: 'nowrap', letterSpacing: '-0.4px' }} >{dayjs(assign_data.assign_start_time).format('hh:mm A [on] MM/DD/YYYY')}</Typography> </Box>

                                                </Grid>
                                                <Grid xs={6} sm={6} md={6}>
                                                    <Box> <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }} style={{ letterSpacing: '-0.4px', fontWeight: 'bold' }}> End Time </Typography> </Box>
                                                    <Box> <Typography sx={{ typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }} color={appThemeColor} style={{ whiteSpace: 'nowrap', letterSpacing: '-0.4px' }}> {dayjs(assign_data.assign_end_time).format('hh:mm A [on] MM/DD/YYYY')}</Typography> </Box>
                                                </Grid>

                                            </Grid>
                                            <Box>

                                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }} >
                                                    <Typography sx={{ typography: { xs: 'subtitle1', sm: 'subtitle1', md: 'h5' } }} style={{ fontWeight: 'bold' }} color={appThemeColor}  >$ {assign_data.assign_bill_value}</Typography>
                                                    <FormControlLabel label={<Typography sx={{ typography: { xs: 'caption', sm: 'subtitle2' } }}>{(RaiseInvoiceCheckboxList[assign_data.assign_id_encry]) ? 'Remove from List' : 'Add to List'}</Typography>}
                                                        control={
                                                            <Checkbox icon={<AddCircleIcon fontSize='small' sx={{ color: '#89B601' }} />} checked={(RaiseInvoiceCheckboxList[assign_data.assign_id_encry]) ? true : false} inputProps={{ 'data-billvalue': assign_data.assign_bill_value }}
                                                                id={'assign_chk_' + assign_data.assign_id_encry} onChange={(evt) => { CheckboxHandleChange(assign_data.assign_id_encry, evt.target.checked) }} checkedIcon={<RemoveCircleIcon fontSize='small' sx={{ color: '#EB5757' }} />} />
                                                        }
                                                    />
                                                </Box>
                                            </Box>
                                        </Box>
                                    </CardContent>
                                    <CardActions sx={{ display: 'block', padding: 0 }}>
                                        <Typography align='center' style={{ fontWeight: 'normal' }} sx={{ letterSpacing: '-0.2px', typography: { xs: 'caption', sm: 'subtitle2', md: 'subtitle1' } }}   >{assign_data.assign_applied_timezone_daylight}</Typography>

                                    </CardActions>
                                </Card>
                            </Grid>)

                        })} </Grid>}

                        {viewNewAssignmentRequestButton === 'view_all_requests_button' && <Box sx={{ mt: 2, mb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'center' }} >
                                <LoadingButton sx={{ color: appThemeColor, textTransform: 'none', fontWeight: 'bold' }} onClick={viewAllRequests} loading={viewNewAssignmentRequestButtonSpin} loadingPosition="end" endIcon={<KeyboardDoubleArrowDownIcon />}> Load More </LoadingButton> </Box>
                        </Box>}
                        {viewNewAssignmentRequestButton === 'no_records' && <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2 }}  > <Typography sx={{ color: appThemeColor }}>No Records Found..!</Typography></Box>}
                    </Box>}


                    {/* Raise Invoice file upload page */}
                    {<Box display={RaiseInvoiceStage === 'RaiseInvoiceFileUpload' ? 'block' : 'none'} >

                        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                            <Button variant='contained' endIcon={<ArrowForwardIosOutlinedIcon />} startIcon={<CloudUploadOutlinedIcon />} color={appThemeSecondaryColor} sx={{ backgroundColor: appThemeColor, textTransform: 'none' }} onClick={() => StageMaintain('RaiseInvoiceDefaultPage')} >Default ITI Invoice</Button>
                        </Box>
                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                            <Typography>Or</Typography>
                        </Box>
                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                            <Typography sx={{ mr: 6 }} color={appThemeColor} variant='subtitle1' fontWeight='bold'>Upload Own Invoice</Typography>
                        </Box>
                        <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
                            <Button component="label" color={appThemeSecondaryColor} sx={{ backgroundColor: appThemeColor, textTransform: 'none' }} role={undefined} startIcon={<FileUploadOutlinedIcon />} variant='contained' size='small'> Upload file<input type="file" hidden id="upload_own_invoice_file" onChange={UploadOwnInvoiceFile} /> </Button>
                            {UploadOwnInvoiceFileError !== false && <Button startIcon={<RestartAltOutlinedIcon />} size='small' variant='contained' color='error' sx={{ textTransform: 'none', ml: 0.5 }} onClick={ResetFilesInput}>Reset</Button>}
                        </Box>

                        {UploadOwnInvoiceFileError !== false && <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
                            {(UploadOwnInvoiceFileError === 'ok' && UploadOwnInvoiceFileData.filename !== null) && <Box  ><Box sx={{ width: 180 }} > <Typography sx={{ overflow: 'auto' }} >{UploadOwnInvoiceFileData.filename}</Typography></Box></Box>}
                            {(UploadOwnInvoiceFileError !== 'ok') && <Typography color="red" sx={{ ml: 2 }}>{UploadOwnInvoiceFileError}</Typography>}
                        </Box>}
                        {(UploadOwnInvoiceFileData.blob !== null && UploadOwnInvoiceFileError !== false) && <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>


                            <FileViewerCustom filename={UploadOwnInvoiceFileData.filename} fileurl={UploadOwnInvoiceFileData.blob} exttype={UploadOwnInvoiceFileData.type} height={150} width={250} color='#fff' />


                        </Box>}
                    </Box>}

                    {RaiseInvoiceStage === 'RaiseInvoiceDefaultPage' && <Box>
                        <RaiseInvoiceDefaultComp RaiseInvoiceCheckboxList={RaiseInvoiceCheckboxList} DefaultInvoiceHeaderNameSet={DefaultInvoiceHeaderNameSet} />

                    </Box>

                    }

                    {RaiseInvoiceStage === 'RaiseInvoiceFileUploadPreview' && <Box>
                        {(UploadOwnInvoiceFileData.blob !== null && UploadOwnInvoiceFileError !== false) && <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                            <FileViewerCustom filename={UploadOwnInvoiceFileData.filename} fileurl={UploadOwnInvoiceFileData.blob} exttype={UploadOwnInvoiceFileData.type} height='100%' width='100%' color='#fff' canvasheight='100%' canvaswidth='100%' />
                        </Box>}
                    </Box>}

                    {RaiseInvoiceStage === 'RaiseInvoiceFileUploadFinal' && <Box>
                        <Box>
                            {(UploadOwnInvoiceFileData.blob !== null && UploadOwnInvoiceFileError !== false) && <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                                <FileViewerCustom filename={UploadOwnInvoiceFileData.filename} fileurl={UploadOwnInvoiceFileData.blob} exttype={UploadOwnInvoiceFileData.type} height={150} width='100%' color='#fff' canvaswidth='100%' />
                            </Box>}


                            <Box sx={{ mt: 2 }}>
                                <InputLabel ><Typography color={appThemeColor}  >Invoice Number *</Typography></InputLabel>
                                <OutlinedInput size='small' sx={{ backgroundColor: '#e2e2e2' }} color={appThemeSecondaryColor} id='invoice_number'
                                    onChange={(evt) => InVoiceNumberValueSet(evt.target.value)}
                                    error={(InVoiceNumberErrorMsg !== false)} fullWidth autoComplete='off' />
                                {InVoiceNumberErrorMsg && <FormHelperText error={true}>{InVoiceNumberErrorMsg}</FormHelperText>}
                            </Box>



                        </Box>

                    </Box>}

                </Box>
                <Box sx={{ position: 'fixed', bottom: 55, left: 0, right: 0, backgroundColor: '#ffffff', borderRadius: 2, zIndex: 2 }}>
                    <Box sx={{ ml: 2, mr: 2, mb: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>

                            <Typography> {(RaiseInvoiceStage === 'RaiseInvoiceDefaultPage') ? 'Powered By' : 'No. of Assignments'} </Typography>
                            <Typography>Total Amount</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                            <Box>

                                {(RaiseInvoiceStage === 'RaiseInvoiceDefaultPage') ? <Box>

                                    <Box component="img" alt="Logo" width={70} height={30} src={process.env.REACT_APP_LOGO_URL} sx={{ mt: -1 }} />


                                </Box> :
                                    <Stack direction='row' spacing={2} alignItems='center'>
                                        <Typography color={appThemeColor} fontWeight='bold'>{selectedAssignmentCount}</Typography> <Button variant='contained' disabled={(selectedAssignmentCount === 0) ? true : false} startIcon={<VisibilityOutlinedIcon />} size='small' sx={{ backgroundColor: '#89B601', textTransform: 'none', '&:hover': { backgroundColor: '#799f05' } }} onClick={PreviewDetails}>Preview</Button>
                                    </Stack>}
                            </Box>
                            <Typography color={appThemeColor} fontWeight='bold'>$ {assignmentTotalBillValue}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                            {RaiseInvoiceStage === 'RaiseInvoice1' && <Button variant='contained' endIcon={<ArrowForwardIcon />} disabled={(selectedAssignmentCount === 0) ? true : false} color={appThemeSecondaryColor} sx={{ backgroundColor: appThemeColor, textTransform: 'none', width: 250 }} onClick={() => NextPageTrigger('RaiseInvoiceFileUpload')}>Next</Button>}
                            {RaiseInvoiceStage === 'RaiseInvoiceFileUpload' &&
                                <Box >
                                    <Stack direction='row' spacing={2}>
                                        <Button variant='contained' startIcon={<ArrowBackIcon />} color={appThemeSecondaryColor} sx={{ backgroundColor: appThemeColor, textTransform: 'none' }} onClick={() => StageMaintain('RaiseInvoice1')}>Back</Button>
                                        <Button variant='contained' endIcon={<ArrowForwardIcon />} disabled={(UploadOwnInvoiceFileError === 'ok') ? false : true} color={appThemeSecondaryColor} sx={{ backgroundColor: appThemeColor, textTransform: 'none' }} onClick={() => NextPageTrigger('RaiseInvoiceFileUploadPreview')}>Next</Button>
                                    </Stack>
                                </Box>}
                            {RaiseInvoiceStage === 'RaiseInvoiceDefaultPage' &&
                                <Box >
                                    <Stack direction='row' spacing={2}>
                                        <Button variant='contained' startIcon={<ArrowBackIcon />} color={appThemeSecondaryColor} sx={{ backgroundColor: appThemeColor, textTransform: 'none' }} onClick={() => StageMaintain('RaiseInvoiceFileUpload')} disabled={finalDefaultInvoiceSubmitLoadingButton ? true : false}>Back</Button>
                                        <LoadingButton variant='contained' endIcon={<CheckCircleOutlineOutlinedIcon />} loadingPosition='end' color={appThemeSecondaryColor} sx={{ backgroundColor: appThemeColor, textTransform: 'none' }} loading={finalDefaultInvoiceSubmitLoadingButton} onClick={RaiseInvoiceDefaultInvoiceSubmit} >Submit</LoadingButton>
                                    </Stack>
                                </Box>}
                            {RaiseInvoiceStage === 'RaiseInvoiceFileUploadPreview' &&
                                <Box >
                                    <Stack direction='row' spacing={2}>
                                        <Button variant='contained' startIcon={<ArrowBackIcon />} color={appThemeSecondaryColor} sx={{ backgroundColor: appThemeColor, textTransform: 'none' }} onClick={() => StageMaintain('RaiseInvoiceFileUpload')}>Back</Button>
                                        <Button variant='contained' endIcon={<ArrowForwardIcon />} disabled={(UploadOwnInvoiceFileError === 'ok') ? false : true} color={appThemeSecondaryColor} sx={{ backgroundColor: appThemeColor, textTransform: 'none' }} onClick={() => NextPageTrigger('RaiseInvoiceFileUploadFinal')}>Next</Button>
                                    </Stack>
                                </Box>}
                            {RaiseInvoiceStage === 'RaiseInvoiceFileUploadFinal' &&
                                <Box >
                                    <Stack direction='row' spacing={2}>
                                        <Button variant='contained' startIcon={<ArrowBackIcon />} color={appThemeSecondaryColor} sx={{ backgroundColor: appThemeColor, textTransform: 'none' }} disabled={finalUploadOwnInvoiceSubmitLoadingButton ? true : false} onClick={() => StageMaintain('RaiseInvoiceFileUploadPreview')}>Back</Button>
                                        <LoadingButton variant='contained' endIcon={<CheckCircleOutlineOutlinedIcon />} loadingPosition='end' loading={finalUploadOwnInvoiceSubmitLoadingButton} disabled={(UploadOwnInvoiceFileError === 'ok') ? false : true} color={appThemeSecondaryColor} sx={{ backgroundColor: appThemeColor, textTransform: 'none' }} onClick={RaiseInvoiceFileUploadSubmit}>Submit</LoadingButton>
                                    </Stack>
                                </Box>}

                        </Box>
                    </Box>
                </Box>


            </Box>
        </Box >
    )
}

